// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3LIMB","modalForm":"UpgradeEpcsModal_modalForm__3D8a-","modalFooter":"UpgradeEpcsModal_modalFooter__3l4Aq"};